module.exports = __webpack_public_path__ + "static/media/ph.d94873bd.png";